import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"

import {Page} from "@indebted/components/Page"
import {TextToHTML} from "@indebted/components/TextToHTML"

function PaymentPlanInvalidated({I18n}) {
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.Invalidated.Title}
				</Typography>
			</Grid>

			<Grid>
				<TextToHTML align="left" text={I18n.Invalidated.Message} className="amp-mask" />
			</Grid>
		</Page>
	)
}
export {PaymentPlanInvalidated}
